'use client'

import {Select} from 'antd'
import React from 'react'

import {useCatalogSort} from '@/src/(pages)/catalog/providers'

import * as UI from './options.styled'

export interface CatalogOptionsProps {
  className?: string
  children?: React.ReactNode
  // TODO: Типизация сортировки
  onChange?: (options: {sort: string}) => void | Promise<void>
  // TODO: Типизация сортировки
  sort: {
    title: string
    value: string
    selected: boolean
  }[]
}

export const CatalogOptions = ({className, children, sort, onChange}: CatalogOptionsProps) => {
  return (
    <UI.Wrapper className={className}>
      <SortOptions onChange={onChange} options={sort} />
      {children}
    </UI.Wrapper>
  )
}

// TODO: намешаны данные и из пропс и из хука, нужно выбрать что-то одно
const SortOptions = ({options}: {onChange: CatalogOptionsProps['onChange']; options: CatalogOptionsProps['sort']}) => {
  const {sort, onChange} = useCatalogSort(options)

  return (
    <UI.SortOptions>
      <span>Сортировать по</span>

      <Select
        onChange={onChange}
        defaultValue={sort}
        options={options.map(option => ({...option, label: option.title}))}
      />
    </UI.SortOptions>
  )
}
